import { createSelector } from 'reselect';

const selectCommunicationModule = state => state.communication;
const selectSocket = createSelector(selectCommunicationModule, state => state.socket);

export default {
  isConnected: createSelector(selectSocket, state => state.isConnected),
  isConnecting: createSelector(selectSocket, state => state.connecting),
  token: createSelector(selectSocket, state => state.token),
  tokenExpires: createSelector(selectSocket, state => state.tokenExpires),
};
